export default "__VITE_ASSET__Dxo1$4gE__"